<template>
  <div class="main">
    <Home v-show="currentPageName === 'Home'" />
    <RouteSearchRoot v-show="currentPageName === 'RouteSearch'" />
    <JyutaiSearchRoot v-show="currentPageName === 'JyutaiSearch'" />
    <Notify v-show="currentPageName === 'Notify'" />
    <MyPageRoot v-show="currentPageName === 'MyPage'" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import MyPageRoot from "@/components/Pages/MyPageRoot";
import RouteSearchRoot from "@/components/Pages/RouteSearchRoot";
import JyutaiSearchRoot from "@/components/Pages/JyutaiSearchRoot";
import Home from "@/components/Pages/Home";
import Notify from "@/components/Pages/Notify";
import firebase from "../../firebase";

export default {
  name: "main",
  components: {
    MyPageRoot,
    RouteSearchRoot,
    JyutaiSearchRoot,
    Home,
    Notify,
  },
  computed: {
    ...mapState(["currentPageName"]),
  },
  methods: {
    ...mapMutations(["setCurrentLatLng"]),
    setLocation() {
      let setCurrentLatLng = this.setCurrentLatLng;
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setCurrentLatLng({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          firebase.putLocation();
        },
        function (err) {
          var msgs = [
            err.message,
            "位置情報の取得を許可されていません。",
            "位置情報の取得に失敗しました。",
            "位置情報を取得中にタイムアウトしました。",
          ];
          window.alert(msgs[err.code]);
        },
        { maximumAge: 0 },
      );
    },
  },
  mounted() {
    this.setLocation();
    setInterval(() => {
      this.setLocation();
    }, 30000);
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
</style>



// WEBPACK FOOTER //
// src/components/Pages/Main.vue